import { render, staticRenderFns } from "./ApplicationGuideOverlay.vue?vue&type=template&id=3996c1b8&scoped=true"
import script from "./ApplicationGuideOverlay.vue?vue&type=script&lang=js"
export * from "./ApplicationGuideOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996c1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3996c1b8')) {
      api.createRecord('3996c1b8', component.options)
    } else {
      api.reload('3996c1b8', component.options)
    }
    module.hot.accept("./ApplicationGuideOverlay.vue?vue&type=template&id=3996c1b8&scoped=true", function () {
      api.rerender('3996c1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApplicationGuideOverlay.vue"
export default component.exports